import _classCallCheck from "/home/aurel/hubo-front/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/aurel/hubo-front/node_modules/@babel/runtime/helpers/esm/createClass";
import _createSuper from "/home/aurel/hubo-front/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/aurel/hubo-front/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @license Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module engine/view/observer/tabobserver
 */
import Observer from './observer';
import BubblingEventInfo from './bubblingeventinfo';
import { keyCodes } from '@ckeditor/ckeditor5-utils/src/keyboard';
/**
 * Tab observer introduces the {@link module:engine/view/document~Document#event:tab `Document#tab`} event.
 *
 * Note that because {@link module:engine/view/observer/tabobserver~TabObserver} is attached by the
 * {@link module:engine/view/view~View}, this event is available by default.
 *
 * @extends module:engine/view/observer/observer~Observer
 */

var TabObserver = /*#__PURE__*/function (_Observer) {
  _inherits(TabObserver, _Observer);

  var _super = _createSuper(TabObserver);

  /**
   * @inheritDoc
   */
  function TabObserver(view) {
    var _this;

    _classCallCheck(this, TabObserver);

    _this = _super.call(this, view);
    var doc = _this.document;
    doc.on('keydown', function (evt, data) {
      if (!_this.isEnabled || data.keyCode != keyCodes.tab || data.ctrlKey) {
        return;
      }

      var event = new BubblingEventInfo(doc, 'tab', doc.selection.getFirstRange());
      doc.fire(event, data);

      if (event.stop.called) {
        evt.stop();
      }
    });
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(TabObserver, [{
    key: "observe",
    value: function observe() {}
  }]);

  return TabObserver;
}(Observer);
/**
 * Event fired when the user presses a tab key.
 *
 * Introduced by {@link module:engine/view/observer/tabobserver~TabObserver}.
 *
 * Note that because {@link module:engine/view/observer/tabobserver~TabObserver} is attached by the
 * {@link module:engine/view/view~View}, this event is available by default.
 *
 * @event module:engine/view/document~Document#event:tab
 *
 * @param {module:engine/view/observer/domeventdata~DomEventData} data
 */


export { TabObserver as default };